export default {"src":"/_next/static/media/hands.1b6e6913.svg","height":82,"width":121,"blurWidth":0,"blurHeight":0};